
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CountrySelectionService } from './country-selection.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TermsOfUseService {

  constructor(private http: HttpClient, private countrySelectionService: CountrySelectionService) { }

  getTermsOfUse(): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('terms_of_use', country);
        return this.http.get<any[]>(apiUrl);
      })
    );
  }
}
